import { useEffect, useRef } from "react";
import rietkuilWord from "@/assets/rietkuil-word.png";



export default function Hero({ onNav }: { onNav: (id: string) => void }) {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const tagRef = useRef<HTMLParagraphElement>(null);
  const btnsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const delay = (el: HTMLElement | null, ms: number) => {
      if (!el) return;
      setTimeout(() => {
        el.style.opacity = "1";
        el.style.transform = "translateY(0)";
      }, ms);
    };
    delay(tagRef.current, 200);
    delay(titleRef.current, 500);
    delay(btnsRef.current, 1300);
  }, []);

  return (
    <section id="home" className="relative w-full overflow-hidden grain" style={{ height: "100svh" }}>
      <img
        alt="Rietkuil Farmhouse — Free State, South Africa"
        className="absolute inset-0 w-full h-full object-cover object-bottom img-washed"
        src="https://storage.readdy-site.link/project_files/613593af-90e6-4fd5-9a7c-ed9cd3136aa5/c4dc3ee6-1682-4ecf-92d1-b7f92eb92199_ChatGPT-Image-Jun-4-2026-11_19_39-AM.png?v=0cf6d76b39749be5f38c5b5d1b007c29"
      />

      <div className="absolute bottom-0 left-0 right-0 z-10 px-10 md:px-16 pb-14 md:pb-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <p
              ref={tagRef}
              className="text-white/70 text-sm tracking-[0.1em] uppercase font-sans font-medium mb-4"
              style={{
                opacity: 0,
                transform: "translateY(10px)",
                transition: "opacity 1.1s cubic-bezier(0.22,1,0.36,1), transform 1.1s cubic-bezier(0.22,1,0.36,1)"
              }}
            >
              SELF-CATERING FARM HOUSE IN THE FREE STATE
            </p>
            <h1
              ref={titleRef}
              className="font-normal leading-none"
              style={{
                opacity: 0,
                transform: "translateY(24px)",
                transition: "opacity 1.4s cubic-bezier(0.22,1,0.36,1), transform 1.4s cubic-bezier(0.22,1,0.36,1)"
              }}
              aria-label="Rietkuil"
            >
              <img
                src={rietkuilWord}
                alt="Rietkuil"
                className="block w-auto"
                style={{ height: "clamp(4.5rem, 13vw, 11rem)" }}
              />
            </h1>

          </div>
          <div
            ref={btnsRef}
            className="flex flex-col gap-3 md:items-end pb-1"
            style={{
              opacity: 0,
              transform: "translateY(12px)",
              transition: "opacity 1.2s cubic-bezier(0.22,1,0.36,1), transform 1.2s cubic-bezier(0.22,1,0.36,1)"
            }}
          >
            <button
              onClick={() => onNav("rooms")}
              className="px-8 py-3 bg-white/90 text-sm tracking-[0.1em] uppercase font-sans font-medium hover:bg-white transition-all duration-500 whitespace-nowrap cursor-pointer rounded-full w-fit"
              style={{ color: "#3C3530" }}
            >
              Explore Rooms
            </button>
            <button
              onClick={() => onNav("booking")}
              className="px-8 py-3 bg-white/90 text-sm tracking-[0.1em] uppercase font-sans font-medium hover:bg-white transition-all duration-500 whitespace-nowrap cursor-pointer rounded-full w-fit"
              style={{ color: "#3C3530" }}
            >
              Book a Stay
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-0 opacity-20">
        <div className="w-px h-14 bg-white" style={{ animation: "pulse 3s ease-in-out infinite" }}></div>
      </div>
    </section>
  );
}